import React from "react";


const DescriptionField = ({id, description}) => {
    return <small id={id} className='form-text text-muted mb-2'>{description}</small>
};

export default DescriptionField;
